<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: Number,
            field: String,

            label: String,
            labelWidth: String,
            labelOptions: Array,
            labelDisabled: {
                type: Boolean,
                default: false,
            },
            labelValue: [String, Number],
            currency: [String, Number],
            currencyField: String,
            currencyDisabled: {
                type: Boolean,
                default: false,
            },
            iso: {
                type: Boolean,
                default: true,
            },

            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: ''
            }
        },
        methods: {
            ...mapActions('dictionaries/currency/select', {
                get: 'get',
            }),
            change_value(v) {
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            change_currency(v) {
                this.$emit('input-currency', v);
                this.$emit('update:currencyValue', v);
                this.$emit('change-currency', v);
                if (this.currencyField) {
                    this.$emit('change-currency-field', {
                        field: this.currencyField,
                        value: v,
                    });
                }
            },
            input_currency(v) {
                this.$emit('input-currency', v);
                this.$emit('update:currencyValue', v);
                if (this.currencyField) {
                    this.$emit('input-currency-field', {
                        currencyField: this.currencyField,
                        value: v,
                    });
                }
            },
            change_label(v) {
                this.$emit('update:labelValue', v);
                this.$emit('change-label', v);
                if (this.labelField) {
                    this.$emit('change-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_label(v) {
                this.$emit('update:labelValue', v);
                if (this.labelField) {
                    this.$emit('input-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
        },
        computed: {
            ...mapGetters('dictionaries/currency/select', {
                list: 'list'
            }),
        },
        watch: {},
        mounted() {
            this.get();
        },

        components: {},
    }
</script>
<template>
    <form-group class="form-sum" :label-width="labelWidth" append :label="label||(labelOptions?' ': '')">
        <el-select
                slot="labelSelect"
                v-if="labelOptions"
                :value="labelValue"
                :disabled="disabled||labelDisabled"
                @change="change_label"
                @input="input_label">
            <el-option v-for="item in labelOptions"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <input-sum
                :value="value"
                @change="change_value"
                @input="input_value"
                :disabled="disabled">
        </input-sum>
        <el-select
                slot="append"
                :value="currency"
                @change="change_currency"
                @input="input_currency"
                :disabled="disabled||currencyDisabled"
                :style="{width:iso?'80px':'auto'}">
            <el-option v-for="item in list"
                       :value="item.value"
                       :label="iso?item.iso:item.label"
                       :key="item.value">
            </el-option>
        </el-select>
    </form-group>
</template>
<style lang="scss">
</style>
